const initialState = {
  isRemember: true,
  userName: "",
  password: "",
  schemeId: "",
  scheme_Id: "",
  name: "",
  permittedSections: [],
  sideBarScroll: "",
  roleName:""
};

const loginReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "REMEMBER":
      return {
        ...state,
        isRemember: payload,
      };

    case "LOGIN":
      return {
        ...state,
        userName: payload.userName,
        password: payload.password,
      };

    case "NAME":
      return {
        ...state,
        name: payload.name,
        _id: payload._id,
        roleId: payload.roleId
      };

    case "SCHEMEID":
      return {
        ...state,
        schemeId: payload,
      };

    case "SCHEME_ID":
      return {
        ...state,
        scheme_Id: payload,
      };

    case "PERMITTED_SECTION":
      return {
        ...state,
        permittedSections: payload,
      };

    case "MODIFIY_USER_NAME": {
      return {
        ...state,
        name: payload,
      };
    }
    case "UPDATE_PROFILE": {
      return {
        ...state,
        ...payload
      };
    }
    case "STORESIDEBAR": {
      return {
        ...state,
        sideBarScroll: payload,
      }
    }
     case "SET_ROLE": {
      return {
        ...state,
        roleName: payload,
      }}
    default:
      return state;
  }
};

export default loginReducer;
